import { IServerResponse, getFirstChildNode, IXmlNode } from '@/app-modules/server-communications';
import { inject } from 'inversify';
import { SERVICE_IDENTIFIERS } from '@/app-modules/_ioc/service-identifiers';
import { BaseResponse } from '@/components/game/_domain/server/_base/base-response';
import { BoxNumbersData } from '@/components/game/_domain/server/prize/prize-data';
import { IBoxNumbersDataFactory } from '@/components/game/_domain/server/_factory/prize-data-factory';
import { GameIdentity } from '@/components/game/_domain/models';

class BoxNumbersResponse extends BaseResponse<BoxNumbersData> {
  constructor(
    @inject(SERVICE_IDENTIFIERS.IBoxNumbersDataFactory)
    private boxNumbersDataFactory: IBoxNumbersDataFactory,
    private gameIdentity: GameIdentity) {
    super();
  }

  public filter(response: IServerResponse): boolean {
    return /command="boxnumbers"/g.test(response.Contents);
  }

  public map(response: IServerResponse): BoxNumbersData {
    const node: Nullable<IXmlNode> = getFirstChildNode(response.Contents);
    if (node === null) {
      throw new Error('Failed to map Box Numbers Response');
    }

    return this.boxNumbersDataFactory.getInstance(this.gameIdentity, node);
  }
}

export { BoxNumbersResponse };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/game/_domain/server/boxnumbers/boxnumbers-response.ts